import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'callDuration'
})
export class CallDurationPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    const seconds: number = Number(value);
    if (isNaN(seconds) || seconds <= 0) return '00:00:00';

    const h: number = Math.floor(seconds / 3600);
    const m: number = Math.floor((seconds % 3600) / 60);
    const s: number = seconds % 60;

    return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
  }

  private pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
}
